import { styled } from '@airwallex/theme';
export const labelStyle = {
  fontWeight: '500',
};

export const informationWrapperStyle = {
  gap: '4px',
  padding: '4px 0',
};

export const MemoWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.semanticColors.background.secondary};
  padding: 12px 16px;
  border-radius: 6px;
`;
